import {Col, FormGroup, Input, Label} from "reactstrap";
import React from "react";
import {withErrorBoundary} from "../../../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../../../boundaries/GeneralErrorBoundary";

const RubrikRscInputs = ({
                           device,
                           array_name,
                           handleInputChange,
                           lgColSize,
                       }) => {
    if (['RUBRIK_RSC_DEVICE'].includes(device?.trim().toUpperCase())) {
        return (
            <>
                <Col lg={lgColSize} sm={6}>
                    <FormGroup>
                        <Label htmlFor="array_name">Cluster UUID </Label>
                        <span className="badge bg-danger">Required </span>
                        <Input
                            required={true}
                            type="text"
                            name="array_name"
                            value={array_name}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
            </>
        );
    } else {
        return null;
    }
};

export default withErrorBoundary(RubrikRscInputs, GeneralErrorBoundary);
